export default "__VITE_ASSET__DMRXI$I4__"